import errorFallbackUI from "components/molecules/ErrorFallbackUI.tsx/ErrorFallbackUI";
import { ComponentErrorBoundary } from "components/molecules/ErrorStates";
import { Table } from "components/molecules/Table";
import ReorderMeasuresModal from "components/organisms/Modals/ReorderMeasuresModal/ReorderMeasuresModal";
import { useFormattedCarbonReductionData } from "pages/BuildingPage/Helper/BuildingPage.helper";
import posthog from "posthog-js";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useCustomPlanSidebarState from "recoilStore/CustomPlan/useCustomPlanSidebarState";
import { TABLE_IDS } from "utils/constants";
import "./CustomPlan.scss";
import CustomPlanHeader from "./Header/CustomPlanHeader";

interface CustomPlanProps {
    buildingModelCarbonReductionPlan: BuildingModelCarbonReductionPlan;
    buildingModel: Building;
}

function CustomPlan({ buildingModel, buildingModelCarbonReductionPlan }: CustomPlanProps) {
    const navigate = useNavigate();
    const {
        state: { selectedRows },
        setState: setCustomPlanSidebarState,
    } = useCustomPlanSidebarState();

    const { tableColumns, dataSource } = useFormattedCarbonReductionData(
        buildingModelCarbonReductionPlan.plan.carbonReductionMeasures,
        buildingModel.grossFloorArea,
        buildingModelCarbonReductionPlan.plan.carbonReductionPlanUid
    );

    const planStartYear = buildingModelCarbonReductionPlan.plan.startYear;
    const planEndYear = buildingModelCarbonReductionPlan.plan.endYear;

    const [reorderModalIsOpen, setReorderModalIsOpen] = useState(false);

    const handleSelectedRowsChange = (rows: CustomPlanDataSource[]) => {
        setCustomPlanSidebarState((state) => ({
            ...state,
            selectedRows: rows,
        }));
    };

    const handleRowClick = (row: CustomPlanDataSource) => {
        navigate(`/building/${buildingModel.buildingModelUid}/measures/${row.carbonReductionMeasureUid}`);
        posthog.capture("projects_table_row_clicked", {
            project: row.carbonReductionMeasureType,
        });
    };
    return (
        <div>
            <ComponentErrorBoundary fallback={errorFallbackUI("tableError")} originComponent="ProjectsReport">
                <CustomPlanHeader
                    grossFloorArea={buildingModel.grossFloorArea}
                    buildingModelCarbonReductionPlan={buildingModelCarbonReductionPlan}
                    setReorderModalIsOpen={() => setReorderModalIsOpen(!reorderModalIsOpen)}
                />

                <div className="measures-projects-report-table">
                    <Table
                        dataSource={dataSource}
                        columns={tableColumns}
                        className="measures-projects-report-table"
                        pagination={false}
                        selectedRows={selectedRows}
                        setSelectedRows={handleSelectedRowsChange}
                        onRowClick={handleRowClick}
                        parentComponentWithSearchBarId={TABLE_IDS.CUSTOM_PLAN}
                        defaultOrderBy={{ key: "yearApplied", order: "asc" }}
                        getRowHref={(row) =>
                            `/building/${buildingModel.buildingModelUid}/measures/${row.carbonReductionMeasureUid}`
                        }
                    />
                </div>

                <ReorderMeasuresModal
                    modalIsOpen={reorderModalIsOpen}
                    onCancel={() => setReorderModalIsOpen(false)}
                    dataSource={dataSource}
                    planStartYear={planStartYear}
                    planEndYear={planEndYear}
                />
            </ComponentErrorBoundary>
        </div>
    );
}

export default CustomPlan;
